import React, { useState } from "react";
import Icon from "../ui/icon";
import "../../assets/styles/component/layout/sideNav.css";
import { NavLink } from "react-router-dom";

const AdminSideNav = ({ isOnHome, active, userName, emailID, initialPublishers }) => {
  const [publishersOpen, setPublishersOpen] = useState(initialPublishers || false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const togglePublishers = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setPublishersOpen(!publishersOpen);
    setTimeout(() => setIsTransitioning(false), 300);
  };

  return (
    <aside className={active ? "side-nav active" : "side-nav"}>
      <div className="profile-card">
        <Icon name="UserCircle" />
        <div className="userInfo">
          <span>{userName || "User Name"}</span>
          <span>{emailID || "Email ID"}</span>
        </div>
      </div>

      <div className="options full-height">
        <span className="dividing-text">GENERAL</span>

        <NavLink
          style={!isOnHome ? { color: "#727272" } : {}}
          to="/admin"
          className="option"
        >
          <div>
            <Icon name="Home" className="main-icon" />
            <span>Dashboard</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        <NavLink to="/admin/campaigns" className="option">
          <div>
            <Icon name="ListBullet" className="main-icon" />
            <span>Campaigns</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        <NavLink to="/admin/reports" className="option">
          <div>
            <Icon name="ChartBar" className="main-icon" />
            <span>Reports</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        <span className="dividing-text">MANAGEMENT</span>

        {/* Publishers Expandable Section */}
        <div className="campaigns-section">
          <div
            className={`campaigns-header ${publishersOpen ? 'open' : ''}`}
            onClick={togglePublishers}
          >
            <div className="header-content">
              <Icon name="Users" className="main-icon" />
              <span>Publishers</span>
            </div>
            <Icon
              name="ChevronDown"
              className={`campaigns-chevron ${publishersOpen ? 'rotate' : ''}`}
            />
          </div>

          <div className={`campaigns-submenu ${publishersOpen ? 'expanded' : 'collapsed'}`}>
            <NavLink
              to="/admin/publishers"
              className="submenu-option"
              onClick={(e) => e.stopPropagation()}
            >
              <Icon name="RectangleStack" className="submenu-icon" />
              <span>All Publishers</span>
            </NavLink>

            <NavLink
              to="/admin/approved-publishers"
              className="submenu-option"
              onClick={(e) => e.stopPropagation()}
            >
              <Icon name="CheckBadge" className="submenu-icon" />
              <span>Approved Publishers</span>
            </NavLink>
          </div>
        </div>

        <NavLink to="/admin/manage-postbacks" className="option">
          <div>
            <Icon name="Link" className="main-icon" />
            <span>Postbacks</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        <NavLink to="/admin/invoices" className="option">
          <div>
            <Icon name="DocumentText" className="main-icon" />
            <span>Invoices</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        <NavLink to="/admin/requests" className="option">
          <div>
            <Icon name="RectangleStack" className="main-icon" />
            <span>Requests</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        <span className="dividing-text">PROFILE</span>

        <NavLink to="/admin/profile" className="option">
          <div>
            <Icon name="UserCircle" className="main-icon" />
            <span>Profile</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        <NavLink to="/admin/settings" className="option">
          <div>
            <Icon name="Cog6Tooth" className="main-icon" />
            <span>Settings</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        <NavLink to="/admin/postback" className="option">
          <div>
            <Icon name="Link" className="main-icon" />
            <span>Postback</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>
      </div>
    </aside>
  );
};

export default AdminSideNav;